import React from 'react';
import cc from 'classcat';
import { Link, LinkProps } from 'react-router-dom';
import {
  Button as BPButton,
  ButtonProps as IButtonProps
} from '@blueprintjs/core';
import './button.scss';

/**
 * Extends Blueprint <Button />
 * https://blueprintjs.com/docs/#core/components/button
 *
 * We extend two interfaces here so we can add additional type checking
 * for native button attributes like onmouseover. Given that both IButtonProps
 * and React.ButtonHTMLAttributes have an onClick type attribute, we must define our own
 * LinkProps['to'] retrieves the to value on the LinkProps interface
 */

interface ButtonProps extends IButtonProps {
  linkTo?: LinkProps['to'];
  bare?: boolean;
  target?: string;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
}

/**
 * bare styles are meant to mimic a regular text link
 */
const Button: React.FC<ButtonProps> = ({
  linkTo,
  bare,
  target,
  children,
  className,
  ...props
}) => {
  const classes = cc([
    className ? className : undefined,
    bare ? 'bare' : 'not-bare'
  ]);

  const btn = (
    <BPButton className={classes} {...props}>
      {children}
    </BPButton>
  );
  if (linkTo) {
    return (
      <Link className="hover-no-underline" to={linkTo} target={target}>
        {btn}
      </Link>
    );
  }
  return btn;
};

export default Button;
